"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicKeyEntry = exports.SignedAssetResponse = exports.ApprovalManifest = exports.ComposerApprovalManifestV1 = exports.SourceApprovalManifestV1 = exports.AssetApprovalManifestV1 = void 0;
const zod_1 = require("zod");
const enums_js_1 = require("./enums.js");
const Sha256Hex = zod_1.z.string().regex(/^[a-f0-9]{64}$/, 'sha256 must be lowercase hex (64 chars)');
const Base = zod_1.z.object({
    v: zod_1.z.literal(1),
    kind: zod_1.z.enum(enums_js_1.ManifestKinds),
    resource_version_id: zod_1.z.string().uuid().optional(),
    composer_version_id: zod_1.z.string().uuid().optional(),
    version: zod_1.z.number().int().positive(),
    tenant_id: zod_1.z.string().uuid(),
    approved_by: zod_1.z.string().uuid(),
    approved_at: zod_1.z.string().datetime(),
    expires_at: zod_1.z.string().datetime().nullable(),
    is_permanent: zod_1.z.boolean(),
});
exports.AssetApprovalManifestV1 = Base.extend({
    kind: zod_1.z.literal('displaycms.asset.approval/v1'),
    resource_version_id: zod_1.z.string().uuid(),
    content_type: zod_1.z.string().min(1).max(128),
    sha256: Sha256Hex,
    size_bytes: zod_1.z.number().int().nonnegative(),
});
exports.SourceApprovalManifestV1 = Base.extend({
    kind: zod_1.z.literal('displaycms.source.approval/v1'),
    resource_version_id: zod_1.z.string().uuid(),
    source_kind: zod_1.z.enum(['rss', 'web_page']),
    source_url: zod_1.z.string().url(),
    sanitizer_profile: zod_1.z.string().min(1),
    snapshot_sha256: Sha256Hex,
    fetched_at: zod_1.z.string().datetime(),
});
exports.ComposerApprovalManifestV1 = Base.extend({
    kind: zod_1.z.literal('displaycms.composer.approval/v1'),
    composer_version_id: zod_1.z.string().uuid(),
    programs_digest: Sha256Hex,
    // Optional composition-level background-music track signed INTO the manifest
    // so it cannot be tampered. Emitted only when set; JCS omits it otherwise, so
    // manifests for compositions without background music are byte-identical to
    // the pre-feature output (existing signatures keep verifying).
    background_audio_resource_version_id: zod_1.z.string().uuid().optional(),
});
exports.ApprovalManifest = zod_1.z.discriminatedUnion('kind', [
    exports.AssetApprovalManifestV1,
    exports.SourceApprovalManifestV1,
    exports.ComposerApprovalManifestV1,
]);
exports.SignedAssetResponse = zod_1.z.object({
    bytes_url: zod_1.z.string().min(1),
    manifest_canonical_json: zod_1.z.string().min(1),
    signature_b64: zod_1.z.string().min(1),
    signing_key_id: zod_1.z.string().uuid(),
});
exports.PublicKeyEntry = zod_1.z.object({
    kid: zod_1.z.string().uuid(),
    algorithm: zod_1.z.literal('ed25519'),
    public_key_b64: zod_1.z.string().min(1),
    activated_at: zod_1.z.string().datetime(),
    status: zod_1.z.enum(enums_js_1.SigningKeyStatuses),
});
//# sourceMappingURL=manifest.schema.js.map